var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.breadcrumbs.length
    ? _c(
        "div",
        {
          staticClass:
            "editor-footer px-2 py-1 border-top rounded rounded-top-0 small",
          class: { "bg-light": !_setup.isDarkMode },
        },
        [
          _c(
            "nav",
            {
              staticStyle: { "--bs-breadcrumb-divider": "''" },
              attrs: { "aria-label": "breadcrumb" },
            },
            [
              _c(
                "ol",
                { staticClass: "breadcrumb mb-0" },
                _vm._l(_setup.breadcrumbs, function (crumb, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "breadcrumb-item small",
                      class: { "pe-2": index === 0 },
                      attrs: { role: "button" },
                      on: {
                        click: function ($event) {
                          return _setup.selectCrumb(crumb)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(crumb.name) +
                          "\n            "
                      ),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }